<script setup>
defineOptions({
  name: 'EditUser',
});
import { ref, watch, toRef, computed } from 'vue';

const props = defineProps([
  'userName',
  'isAdmin',
  'userId',
  'newUser',
  'lastLoginAttempt',
]);

const emit = defineEmits(['remove', 'changeuser', 'createuser', 'cancel']);

const remove = (id) => {
  emit('remove', id);
};
const cancel = () => {
  emit('cancel');
};
const submitText = props.newUser ? 'nieuwe user' : 'pas user aan';
const new_name = ref('');

const user_name = toRef(props, 'userName');
new_name.value = user_name.value;
const user_id = toRef(props, 'userId');
const is_admin = ref(props.isAdmin);
const handleSubmit = async () => {
  if (props.newUser) {
    emit('createuser', {
      user_name: new_name.value,
      password: password.value,
      is_admin: is_admin.value,
    });
  } else {
    emit('changeuser', {
      user_id: user_id.value,
      user_name: new_name.value,
      password: password.value,
      is_admin: is_admin.value,
    });
  }
};
const password = ref('');

const hidePassword = ref(true);

const passwordFieldIcon = computed(() =>
  hidePassword.value ? 'icon-eye-off' : 'icon-eye'
);
const passwordFieldType = computed(() =>
  hidePassword.value ? 'password' : 'text'
);
watch([user_name], () => {
  new_name.value = user_name.value;
});
</script>
<template>
  <td>
    <span v-if="!newUser">{{ user_id }}</span>
  </td>
  <td>
    <div class="field">
      <div class="control">
        <input
          v-model.trim="new_name"
          class="input"
          type="text"
          title="newusername"
          placeholder="new username"
          name="newusername"
        />
      </div>
    </div>
  </td>
  <td>
    <div class="field">
      <div class="control">
        <label class="radio">
          <input
            type="radio"
            v-model="is_admin"
            value="Y"
            :checked="is_admin == 'Y'"
          />
          Yes
        </label>
        <label class="radio">
          <input
            type="radio"
            v-model="is_admin"
            value="N"
            :checked="is_admin != 'Y'"
          />
          No
        </label>
      </div>
    </div>
  </td>

  <td>
    <div class="field is-grouped">
      <p class="control has-icons-right">
        <input
          v-model.trim="password"
          class="input"
          :type="[passwordFieldType]"
          title="newpassword"
          placeholder="new password"
          name="newpassword"
        />
        <span class="icon is-large is-right">
          <i
            :class="[passwordFieldIcon]"
            class="icon-click"
            @click="hidePassword = !hidePassword"
          ></i>
        </span>
      </p>

      <div class="control">
        <button type="submit" @click="handleSubmit" class="button is-link">
          {{ submitText }}
        </button>
      </div>
    </div>
  </td>
  <td>
    {{
      new Date(lastLoginAttempt).toLocaleString([], {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    }}
  </td>

  <td v-if="!newUser">
    <button class="button is-warning" @click="remove(user_id)">remove</button>
  </td>
  <td v-else>
    <button class="button is-link is-light" @click="cancel">cancel</button>
  </td>
</template>
